import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import {
  LoginView,
  HomeDashboardView,
  QuotationsView,
  OrderSalesView,
  DeliveriesView,
  BillingView,
  BillingBorradorView,
  BillingAuthorizationView,
  CreditNoteView,
  DebitNoteView,
  PaymentView,
  ReturnView,
  TransfersView,
  TransfersEntryView,
  TransfersOutputView,
  TransfersRequestView,
  MiddlewareView,
  BussinesPartnerView,
  PurchaseOrderView,
  PurchaseRequestView,
  PurchaseReturnView,
  InventoryDataView,
  GoodsReceiptView,
  InventoryRevaluationView,
  QueryView,
  SalesHelmetsView,
  ExitHelmetsView,
  PurchaseInvoicesView,
  PurchaseDownPaymentsView,
  PurchaseCreditNotesView,
  OutgoingPaymentsView,
  InventoryReportsView,
  InvoiceReserveView,
  PointOfSaleView,
  AdministratorUsersView,
  InventoryView,
  ReportSalesView,
  CollectView,
  RePrintView,
  SucursalView,
  GlobalConfigView,
  BankDepositsView,
  ClosuresView,
  InvoiceAdvanceView,
  BranchClosuresView,
  //#region CARTA PORTE
  FiguraTransporteView,
  TransporteView,
  CartaPorteView,
  //#endregion
  //#region PHASE 2
  PendingTimbraDocsView,
  R2D2,
  //#endregion
  citibanamexView,
  timbraNominasView,
  EmployeeNomina,

  //#region M-SUITE
  AdminRoutesSellersView,
  AdminDeliveries,
  AuthorizePartners,
  PointsCardView,
  AdminDeliveries20,
  NotificationManagement,
  PromotionManagement,
  PartnerDocumentsView,
  PrintTagsItemsView,

  // Precios de entrega
  LandedCosts,

  //Production
  ProductTree,
  ProductionOrder,
  GoodsReceiptProd,
  GoodsIssue,
  ProvConfAssistant,

  //#region MRP
  SalesForecastView,
  MRPAssistantView,
  ReportSelectionCriteriaView,
  //#endregion

  // Resources module
  RscMasterData,
  RscCapacity,


  //#region ######### referral system #########
  AdminReferredSystem,
  ReferredPartners,
  Ambassadors,
  //#endregion

  DeliverView,
  CounterReturns,
  //#region ######### SuggestedRefillModule #########
  SuggestedRefillModule,
  MVentasAdminUsersView,
  WareHouseAdminView,
  //#endregion
  PriceListsView,
  InventoryCountingView,
  InventoryPostingView,
  PurchaseQuotationView,
  DraftView,
  AdminBot,
  ReabsResumeView,
  CutTransferView,
  // Vista registrada abajo para el módulo Soporte > Cortes Pendientes.
  PendingCutsView,
} from './views';
import { connect } from 'react-redux';
import './App.css';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { DISPATCH_ID, BASE_URL } from './libs/utils/Const';
import CacheBuster from './CacheBuster';
import socketService from './libs/sockets/SocketService';
import { PushNotifications } from './components/index'
import config from './config';
import $ from "jquery";
import canalizadosAdminView from "./views/canalizadosAdmin/canalizadosAdminView";
import reProcessMVentasView from "./views/reProcessMVentas/reProcessMVentasView";
import reProcessCeUsoView from "./views/reProcessCeUso/reProcessCeUsoView";
const modules = {
  mktSales: { tit: "Documentos", active: true, Wr: true, grp: 0 },
  quotations: { tit: "Oferta de venta", active: true, Wr: true, grp: 1 },
  orderSales: { tit: "Orden de venta", active: true, Wr: true, grp: 1 },
  deliveries: { tit: "Entregas", active: true, Wr: true, grp: 1 },
  invoice: { tit: "Facturas", active: true, Wr: true, grp: 1 },
  return: { tit: "Devoluciones", active: true, Wr: true, grp: 1 },
  debitNote: { tit: "Nota de débito", active: true, Wr: true, grp: 1 },
  creditNote: { tit: "Nota de crédito", active: true, Wr: true, grp: 1 },
  invoiceAdvance: { tit: "Facturas de anticipo", active: true, Wr: true, grp: 1, },
  invoiceReserve: { tit: "Factura de reserva", active: true, Wr: true, grp: 1 },

  mktPurchase: { tit: "Documentos de Compras", active: true, Wr: true, grp: 0 },
  PurchaseOrder: { tit: "Orden de compra", active: true, Wr: true, grp: 2 },
  PurchaseQuotation: { tit: "Oferta de compra", active: true, Wr: true, grp: 2 },
  PurchaseRequest: {
    tit: "Solicitud de compra",
    active: true,
    Wr: true,
    grp: 2,
  },
  GoodsReceipt: {
    tit: "Entrada de mercancía compras",
    active: true,
    Wr: true,
    grp: 2,
  },
  purchaseReturn: {
    tit: "Devolución de mercancía compras",
    active: true,
    Wr: true,
    grp: 2,
  },
  purchaseInvoice: {
    tit: "Factura de proveedor",
    active: true,
    Wr: true,
    grp: 2,
  },
  purchaseDownPayments: { tit: "Factura de anticipo de proveedor", active: true, Wr: true, grp: 2, },
  purchaseCreditNotes: { tit: "Nota de crédito proveedor", active: true, Wr: true, grp: 2, },
  masterData: { tit: "Datos Maestros", active: true, Wr: true, grp: 0 },
  bussinesPartner: { tit: "Socio de Negocios", active: true, Wr: true, grp: 3 },
  inventoryData: {
    tit: "Artículos de Inventario",
    active: true,
    Wr: true,
    grp: 3,
  },

  banking: { tit: "Gestion de Bancos", active: true, Wr: true, grp: 0 },
  payment: { tit: "Pagos Recibidos", active: true, Wr: true, grp: 4 },
  outgoingPayment: { tit: "Pagos efectuados", active: true, Wr: true, grp: 4 },

  inventory: {
    tit: "Operaciones de Inventario",
    active: true,
    Wr: true,
    grp: 0,
  },
  transfers: { tit: "Trasnferencia de stock", active: true, Wr: true, grp: 5 },
  transfersRequest: {
    tit: "Solicitud de transferencia",
    active: true,
    Wr: true,
    grp: 5,
  },
  transfersEntry: { tit: "Entrada de mercancía", active: true, Wr: true, grp: 5, },
  transfersOutput: { tit: "Salida de mercancía", active: true, Wr: true, grp: 5, },

  printTagsItems: { tit: "Imprimir etiquetas de artículos", active: true, Wr: true, grp: 5, },
  // inventoryRevaluation: {tit: 'Revalorización de inventario', active: true, Wr: true, grp:5},

  inzi: { tit: "Autorizaciones", active: true, Wr: true, grp: 0 },
  invoiceAuthorization: { tit: "Documentos por autorizar", active: true, Wr: true, grp: 6, },
  invoiceBorrador: { tit: "Documentos autorizados", active: true, Wr: true, grp: 6, },

  actions: { tit: 'Acciones Internas', active: true, Wr: true, grp: 0 },
  queryManager: { tit: 'Consultas', active: true, Wr: true, grp: 7 },
  administratorUsers: { tit: 'Administración de usuarios', active: true, Wr: true, grp: 7 },
  sucursales: { tit: 'Sucursales', active: true, Wr: true, grp: 7 },
  globalConfig: { tit: 'Configuración Global', active: true, Wr: true, grp: 7 },
  adminSchedule: { tit: 'Admin. Horarios', active: true, Wr: true, grp: 7 },

  counter: { tit: 'Punto de venta', active: true, Wr: true, grp: 0 },
  pointSales: { tit: 'Venta de mostrador', active: true, Wr: true, grp: 8 },
  // settingsPS: {tit: 'Configuraciones', active: true, Wr: true, grp:8},
  inventoryPS: { tit: 'Inventario', active: true, Wr: true, grp: 8 },
  reportsPS: { tit: 'Reportes', active: true, Wr: true, grp: 8 },
  partnerDocuments: { tit: 'Documentos por Cliente', active: true, Wr: true, grp: 8 },
  payments: { tit: 'Cobranza', active: true, Wr: true, grp: 8 },
  incomingPaymentsPS: { tit: 'Depósitos bancarios', active: true, Wr: true, grp: 8 },
  prints: { tit: 'Re-impresión', active: true, Wr: true, grp: 8 },
  closuresPS: { tit: 'Cierres y cortes', active: true, Wr: true, grp: 8 },
  branchClosuresPS: { tit: 'Cierres de sucursales', active: true, Wr: true, grp: 8 },
  pointsCard: { tit: 'Monedero Electrónico', active: true, Wr: true, grp: 8 },
  // middleware: {tit: 'Middleware', active: true, Wr: true, grp:7},
  // stockAudit: {tit: 'Auditoria de stock', active: true, Wr: true, grp:5},
  consignmentNoteManagement: { tit: 'Gestión de Cartas Porte', active: true, Wr: true, grp: 0 },
  figuresTransport: { tit: 'Figuras de Transporte', active: true, Wr: true, grp: 9 },
  transports: { tit: 'Transportes', active: true, Wr: true, grp: 9 },
  consignmentNote: { tit: 'Carta Porte', active: true, Wr: true, grp: 9 },

  // phase 2 modules
  pendingTimbraDocs: { tit: "Documentos pendientes timbre", active: true, Wr: true, grp: 9, },

  //citibanamex
  citibanamex: { tit: "Gestión Citibanamex", active: true, Wr: true, grp: 4 },
  timbraNom: { tit: "Timbrado de nominas", active: true, Wr: true, grp: 4 },

  //---------------------------------MOBILE SUITE-----------------------------------------
  adminSellersRoutes: { tit: 'Admin. Rutas vendedores', active: true, Wr: true, grp: 9 },
  adminDeliveriesRoutes: { tit: "Gestor de Entregas Físicas", active: true, Wr: true, grp: 9 },
  landedCosts: { tit: "Precios de Entrega", active: true, Wr: true, grp: 9 },

  //#region MRP
  salesForecast: { tit: "Previsiones", active: true, Wr: true, grp: 1 },
  mrpAssistant: { tit: "Asistente MRP", active: true, Wr: true, grp: 1 },
  reportSelectionCriteria: { tit: "Recomendación de pedido", active: true, Wr: true, grp: 1, },

  // Producción
  productTree: { tit: "Lista de Materiales", active: true, Wr: true, grp: 9 },
  productionOrder: {
    tit: "Orden de Fabricación",
    active: true,
    Wr: true,
    grp: 9,
  },
  goodsReceiptProd: {
    tit: "Recibo de Producción",
    active: true,
    Wr: true,
    grp: 9,
  },
  goodsIssue: {
    tit: "Emisión para Producción",
    active: true,
    Wr: true,
    grp: 9,
  },
  provConfAssistant: {
    tit: "Asistente de confirmación de aprovisionamiento",
    active: true,
    Wr: true,
    grp: 9,
  },

  //Resources
  rscMasterData: { tit: 'Datos maestros del recurso', active: true, Wr: true, grp: 1 },
  // rscCapacity: { tit: 'Capacidad de recursos', active: true, Wr: true, grp: 1 },

  //#region ######### referral system #########
  ambassadors: { tit: 'Embajadores', active: true, Wr: true, grp: 8 },
  referredPartners: { tit: 'Referidos', active: true, Wr: true, grp: 8 },
  adminReferredSystem: { tit: 'Administrador de referidos', active: true, Wr: true, grp: 8 },
  //#endregion

  //#region ######### refill module #########
  refillModule: { tit: 'Sugerido de resurtidos', active: true, Wr: true, grp: 8 },
  //#endregion

  counterReturns: { tit: "Devolución y/o Cancelaciones", active: true, Wr: true, grp: 8 },
  deliver: { tit: "Entregas(COUNTER ONE)", active: true, Wr: true, grp: 8 },
  //---------------------------------M-VENTAS---------------------------------------------
  mVentas: { tit: 'Gestión M-Ventas', active: true, Wr: true, grp: 0 },
  mAdminUser: { tit: 'Admin. de usuarios(M-Ventas)', active: true, Wr: true, grp: 10 },
  priceList: { tit: "Lista de Precios", active: true, Wr: true, grp: 5 },
  canalizadoAdmin: { tit: 'Canalizados', active: true, Wr: true, grp: 10 },

  /**WAREHOUSE ADMIN */
  wareHouseAdmin: { tit: "Admin. Almacén", active: true, Wr: true, grp: 5, },


  cutTransfers: { tit: "Traspaso de Cortes", active: true, Wr: true, grp: 5, },
  //#region InventoryCounting
  inventoryCounting: { tit: 'Recuento de inventario', active: true, Wr: true, grp: 1 },
  inventoryPosting: { tit: 'Contabilización de stock', active: true, Wr: true, grp: 1 },
  //#endregion


  draftsHead: { tit: "Preliminares", active: true, Wr: true, grp: 0 },
  drafts: { tit: "Documentos Preliminares", active: true, Wr: true, grp: 11 },

  //#region SUPPORT
  support: { tit: 'Soporte', active: true, Wr: true, grp: 0 },//HEADER
  ceUsoReProcess: { tit: 'Reprocesar Cesión de Uso', active: true, Wr: true, grp: 12,type:'admin' },//MODULE
  mVentasReprocess: { tit: 'Reprocesar Documentos MVentas', active: true, Wr: true, grp: 12,type:'admin' },//MODULE
  reabsResume: { tit: "Resumen Reabastecimiento", active: true, Wr: true, grp: 12,type:'admin' },
  // Metadatos de permiso/menú usados por el dashboard y la barra lateral.
  pendingCuts: { tit: 'Cortes Pendientes', active: true, Wr: true, grp: 12, type: 'admin' },
  //#endregion
}
class App extends Component {
  constructor(props) {
    super(props);
    this.pushNotificationRef = React.createRef();
  }

  componentDidMount = async () => {
    const {
      addNotificationReference,
      setModules,
      addPushNotificationReference,
    } = this.props;
    addNotificationReference(this.createNotification);
    addPushNotificationReference(this.createPushNotification);
    await setModules(modules);
    await this.connectSocket();
    $(document).on('hidden.bs.modal', '.modal', () => {
      if ($('.modal.show').length > 0) $('body').addClass('modal-open');
    });
  };

  componentWillUnmount = async () => {
    await socketService.disconnect();
  };

  createNotification = (action) => {
    switch (action.type) {
      case "info":
        NotificationManager.info(
          action.message ? action.message : "",
          action.title ? action.title : "",
          action.timeOut ? action.timeOut : 3000,
          action.callback ? action.callback : null
        );
        break;
      case "success":
        NotificationManager.success(
          action.message ? action.message : "",
          action.title ? action.title : "",
          action.timeOut ? action.timeOut : 3000,
          action.callback ? action.callback : null
        );
        break;
      case "warning":
        NotificationManager.warning(
          action.message ? action.message : "",
          action.title ? action.title : "",
          action.timeOut ? action.timeOut : 3000,
          action.callback ? action.callback : null
        );
        break;
      case "error":
        NotificationManager.error(
          action.message ? action.message : "",
          action.title ? action.title : "",
          action.timeOut ? action.timeOut : 3000,
          action.callback ? action.callback : null
        );
        break;
      default:
        break;
    }
  };

  createPushNotification = (action) => {
    this.pushNotificationRef.current.addNotification(action);
  };

  connectSocket = async () => {
    const currentUser = JSON.parse(
      localStorage.getItem(config.localStorageNamed + "currentUser")
    );

    socketService.setPushNotificationsRef(this.pushNotificationRef);

    // Comentado para local
    await socketService.connect();

    if (currentUser && currentUser.USERID) {
      const { U_FMB_Sucursal, Sucursal, USERID, USER_CODE, ReferredUser } = currentUser;

      const data = {
        pkSucursal: U_FMB_Sucursal,
        sucursal: Sucursal,
        userID: USERID,
        userCode: USER_CODE,
        ReferredUser,
      };

      await socketService.emit("login", data);
    }
  };

  render() {
    const { spinner } = this.props.configReducer;
    const { addNotificationReference } = this.props;
    addNotificationReference(this.createNotification);

    return (
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) {
            return null;
          }

          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }

          return (
            <div className="App content">
              <div className="container contenedor">
                <div className="row">
                  <div className="col outside">
                    {spinner && (
                      <div
                        className="loader"
                        style={{ backgroundColor: "rgba(6,7,8,0.6)" }}
                      >
                        <div className="text-center">
                          <div
                            className="spinner-border text-warning"
                            style={{ width: 45, height: 45 }}
                            role="status"
                          >
                            <span className="sr-only">'Cargando...'</span>
                          </div>
                        </div>
                      </div>
                    )}
                    <NotificationContainer />
                    <PushNotifications ref={this.pushNotificationRef} />
                    <Switch>
                      {/*login*/}
                      <Route exact path="/login" component={LoginView} />
                      {/*Dashboard*/}
                      <Route exact path="/" component={HomeDashboardView} />

                      {/*Views*/}
                      <Route
                        exact
                        path="/quotations"
                        component={QuotationsView}
                      />
                      <Route
                        exact
                        path="/orderSales"
                        component={OrderSalesView}
                      />
                      <Route
                        exact
                        path="/deliveries"
                        component={DeliveriesView}
                      />

                      <Route exact path="/billing" component={BillingView} />
                      <Route
                        exact
                        path="/billingBorrador"
                        component={BillingBorradorView}
                      />
                      <Route
                        exact
                        path="/billingAuthorization"
                        component={BillingAuthorizationView}
                      />

                      <Route exact path="/return" component={ReturnView} />

                      <Route
                        exact
                        path="/debitNote"
                        component={DebitNoteView}
                      />
                      <Route
                        exact
                        path="/creditNote"
                        component={CreditNoteView}
                      />
                      <Route exact path="/payment" component={PaymentView} />
                      <Route
                        exact
                        path="/bussinesPartner"
                        component={BussinesPartnerView}
                      />

                      <Route
                        exact
                        path="/transfers"
                        component={TransfersView}
                      />
                      <Route
                        exact
                        path="/transfersRequest"
                        component={TransfersRequestView}
                      />
                      <Route
                        exact
                        path="/transfersOutput"
                        component={TransfersOutputView}
                      />
                      <Route
                        exact
                        path="/transfersEntry"
                        component={TransfersEntryView}
                      />
                      <Route
                        exact
                        path="/printTagsItems"
                        component={PrintTagsItemsView}
                      />
                      <Route
                        exact
                        path="/inventoryData"
                        component={InventoryDataView}
                      />
                      <Route
                        exact
                        path="/inventoryRevaluation"
                        component={InventoryRevaluationView}
                      />

                      <Route
                        exact
                        path="/middleware"
                        component={MiddlewareView}
                      />
                      <Route exact path="/query" component={QueryView} />

                      <Route
                        exact
                        path="/purchaseOrder"
                        component={PurchaseOrderView}
                      />
                      <Route
                        exact
                        path="/goodsReceipt"
                        component={GoodsReceiptView}
                      />

                      <Route
                        exact
                        path="/purchaseRequest"
                        component={PurchaseRequestView}
                      />
                      <Route
                        exact
                        path="/purchaseReturn"
                        component={PurchaseReturnView}
                      />
                      <Route
                        exact
                        path="/salesHelmets"
                        component={SalesHelmetsView}
                      />
                      <Route
                        exact
                        path="/exitHelmets"
                        component={ExitHelmetsView}
                      />
                      <Route
                        exact
                        path="/purchaseInvoice"
                        component={PurchaseInvoicesView}
                      />
                      <Route exact path="/purchaseDownPayments" component={PurchaseDownPaymentsView} />
                      <Route
                        exact
                        path="/purchaseCreditNotes"
                        component={PurchaseCreditNotesView}
                      />
                      <Route
                        exact
                        path="/outgoingPayments"
                        component={OutgoingPaymentsView}
                      />
                      <Route
                        exact
                        path="/inventoryReports"
                        component={InventoryReportsView}
                      />
                      <Route
                        exact
                        path="/invoiceAdvance"
                        component={InvoiceAdvanceView}
                      />
                      <Route
                        exact
                        path="/invoiceReserve"
                        component={InvoiceReserveView}
                      />

                      <Route
                        exact
                        path="/PointOfSale"
                        component={PointOfSaleView}
                      />

                      <Route
                        exact
                        path="/adminUsers"
                        component={AdministratorUsersView}
                      />
                      <Route
                        exact
                        path="/sucursales"
                        component={SucursalView}
                      />
                      <Route
                        exact
                        path="/globalConfig"
                        component={GlobalConfigView}
                      />
                      <Route
                        exact
                        path="/inventory"
                        component={InventoryView}
                      />
                      <Route
                        exact
                        path="/reportSales"
                        component={ReportSalesView}
                      />
                      <Route
                        exact
                        path="/partnerDocuments"
                        component={PartnerDocumentsView}
                      />
                      <Route exact path="/collect" component={CollectView} />
                      <Route exact path="/rePrint" component={RePrintView} />
                      <Route
                        exact
                        path="/bankDeposits"
                        component={BankDepositsView}
                      />
                      <Route exact path="/closures" component={ClosuresView} />
                      <Route
                        exact
                        path="/branchClosures"
                        component={BranchClosuresView}
                      />

                      {/* #region Carta Porte */}
                      <Route
                        exact
                        path="/figuraTransporte"
                        component={FiguraTransporteView}
                      />
                      <Route
                        exact
                        path="/transporte"
                        component={TransporteView}
                      />
                      <Route
                        exact
                        path="/cartaPorte"
                        component={CartaPorteView}
                      />
                      {/* #endregion */}

                      <Route
                        exact
                        path="/pendingTimbraDocs"
                        component={PendingTimbraDocsView}
                      />
                      <Route exact path="/R2D2" component={R2D2} />
                      <Route exact path="/adminR2D2" component={AdminBot} />

                      {/* #CITIBANAMEX */}
                      <Route
                        exact
                        path="/citibanamex"
                        component={citibanamexView}
                      />
                      {/* TIMBRADO DE NOMINAS */}
                      <Route exact path="/timbraNom" component={timbraNominasView} />
                      <Route exact path="/employeeNom" component={EmployeeNomina} />

                      <Route
                        exact
                        path="/adminDeliveries"
                        component={AdminDeliveries}
                      />
                      <Route
                        exact
                        path="/authorizePartners"
                        component={AuthorizePartners}
                      />
                      <Route
                        exact
                        path="/pointsCard"
                        component={PointsCardView}
                      />
                      <Route exact path="/adminSellersRoutes" component={AdminRoutesSellersView} />

                      <Route
                        exact
                        path="/adminDeliveries20"
                        component={AdminDeliveries20}
                      />

                      {/* #NOTIFICATIONS */}
                      <Route
                        exact
                        path="/notificationManagement"
                        component={NotificationManagement}
                      />

                      {/* #region MRP */}

                      <Route exact path="/salesForecast" component={SalesForecastView} />
                      <Route exact path="/MRPAssistant" component={MRPAssistantView} />
                      <Route exact path="/reportSelectionCriteria" component={ReportSelectionCriteriaView} />

                      {/* #endregion */}

                      {/* #LandedCosts */}
                      <Route exact path="/landedCosts" component={LandedCosts} />

                      {/* #PRODUCTION */}
                      <Route exact path="/productTree" component={ProductTree} />
                      <Route exact path="/productionOrder" component={ProductionOrder} />
                      <Route exact path="/goodsReceiptProd" component={GoodsReceiptProd} />
                      <Route exact path="/goodsIssue" component={GoodsIssue} />
                      <Route exact path="/provConfAssistant" component={ProvConfAssistant} />

                      {/* #RESOURCES */}
                      <Route exact path="/rscMasterData" component={RscMasterData} />
                      <Route exact path="/rscCapacity" component={RscCapacity} />
                      <Route exact path="/PromotionManagement" component={PromotionManagement} />

                      {/* // ######### referral system ######### */}
                      <Route exact path="/adminReferredSystem" component={AdminReferredSystem} />
                      <Route exact path="/ambassadors" component={Ambassadors} />
                      <Route exact path="/referredPartners" component={ReferredPartners} />

                      <Route exact path="/deliver" component={DeliverView} />
                      <Route exact path="/counterReturns" component={CounterReturns} />

                      {/* // ######### suggestedRefill ######### */}
                      <Route exact path="/suggestedRefill" component={SuggestedRefillModule} />
                      {/* #region M-Ventas */}
                      <Route exact path="/mVAdminUser" component={MVentasAdminUsersView} />
                      <Route exact path="/canalizadosAdmin" component={canalizadosAdminView} />
                      {/* #endregion */}
                      {/**WHS ADMIN */}
                      <Route exact path="/Almacenes" component={WareHouseAdminView} />
                      <Route exact path="/ReabsResume" component={ReabsResumeView} />
                      {/* Protegida por la infraestructura de ruta/sesión; renderiza el reporte de cortes pendientes. */}
                      <Route exact path="/PendingCuts" component={PendingCutsView} />
                      <Route exact path="/CutTransfers" component={CutTransferView} />
                      {/* LISTA DE PRECIOS */}
                      <Route exact path="/priceLists" component={PriceListsView} />

                      {/* INVENTORY COUNTING */}
                      <Route exact path="/inventoryCounting" component={InventoryCountingView} />
                      <Route exact path="/InventoryPosting" component={InventoryPostingView} />

                      <Route exact path="/purchaseQuotation" component={PurchaseQuotationView} />
                      <Route exact path="/draft" component={DraftView} />
                      {/* #region SUPPORT */}
                      <Route exact path="/ReprocessDocumentsMVentas" component={reProcessMVentasView} />
                      <Route exact path="/ReprocessCeUso" component={reProcessCeUsoView} />                      
                      {/* #endregion SUPPORT */}
                      <Route exact path="*" component={HomeDashboardView} />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </CacheBuster>
    );
  }
}

const mapStateToProps = (store) => {
  return { configReducer: store.ConfigReducer };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addNotificationReference: (value) =>
      dispatch({ type: DISPATCH_ID.NOTIFICATION_SET_ALERT_REFERENCE, value }),
    addPushNotificationReference: (value) =>
      dispatch({
        type: DISPATCH_ID.PUSH_NOTIFICATION_SET_ALERT_REFERENCE,
        value,
      }),
    setCurrency: (value) =>
      dispatch({ type: DISPATCH_ID.CONFIG_SET_CURRENCY, value }),
    setModules: (value) =>
      dispatch({ type: DISPATCH_ID.CONFIG_SET_MODULES, value }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
